import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

const AccessControl = ({
  permissions,
  allowedPermissions,
  matchAll,
  children,
  renderNoAccess,
}) => {
  const permitted = AccessControl.hasPermission(permissions, allowedPermissions, matchAll);

  if (permitted) {
    return children;
  }
  if (renderNoAccess) {
    return renderNoAccess();
  }
  return null;
};

AccessControl.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  allowedPermissions: PropTypes.arrayOf(PropTypes.string),
  matchAll: PropTypes.bool,
  children: PropTypes.node,
  renderNoAccess: PropTypes.func
};

AccessControl.defaultProps = {
  allowedPermissions: [],
  permissions: [],
  children: null,
  matchAll: false,
  renderNoAccess: () => null,
};

AccessControl.hasPermission = function (permissions, allowedPermissions, matchAll = false) {
  if (!permissions || permissions.length === 0
    || !allowedPermissions || allowedPermissions.length === 0) {
    return false;
  }

  if (matchAll === true) {
    return allowedPermissions.every(permission => permissions.includes(permission));
  }

  return permissions.some(permission => allowedPermissions.includes(permission));
};

// Compose AccessControl component with redux
function mapStateToProps(state) {
  const {
    auth: {
      permissions
    }
  } = state;

  return {
    permissions,
  };
}

export default connect(
  mapStateToProps
)(AccessControl);
